import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import panelsService from "./PanelsService";
const initialState = {
  panel: null,
  isError: false,
  isSuccess: false,
  isLodaing: false,
  massage: "",
};

export const getSinglePanel = createAsyncThunk(
  "panel/single",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.mainUser.data.token;
      return await panelsService.getSinglePanel(id, token);
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const panelSlice = createSlice({
  name: "panel",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLodaing = false;
      state.massage = "";
    },
  },
  extraReducers: {
    [getSinglePanel.pending]: (state) => {
      state.isLodaing = true;
    },
    [getSinglePanel.fulfilled]: (state, action) => {
      state.isLodaing = false;
      state.panel = action.payload;
      state.isSuccess = true;
    },
    [getSinglePanel.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
      state.panel = null;
    },
  },
});

export const { reset } = panelSlice.actions;
export default panelSlice.reducer;
